<template>
  <div class="info-content">
    <ChildTab
      :childrenTabData="childrenTabData"
      :childTabOffsetData="childTabOffsetData"
    />
    <div class="outermost-layer">
    <div class="info-section overview" ref="section1">
      <div class="section-title">
        <div class="title-row">
          <img
            class="nucleus"
            :src="require('@/assets/images/officialWebsite/buleleft.png')"
          />
          <div class="section-title__text">系统描述</div>
          <img
            class="nucleus"
            :src="require('@/assets/images/officialWebsite/blueright.png')"
          />
        </div>
        <p class="title-eng">System overview</p>
      </div>
      <img
        class="overview-image"
        :src="require('@/assets/images/products/meeting/overview.png')"
      />
      <p class="overview-title">
        打造空间+流程+服务一体化的智能会议室管理模式，创造多元化的会议室服务
      </p>
      <p class="overview-p">
        会议室管理系统功能覆盖会议室管理、会议物资服务、会议室预约、会议通知等功能，帮助后勤管理人员实现对会议室的精细化管理。结合高校会议室的实际使用场景，适应校内外不同属性用户的使用需求；同时支持会议物资预定功能，用户可在预约时按需选择物资，以提供更优质的会议服务。
      </p>
    </div>
    <div class="info-section core" ref="section2">
      <div class="section-title">
        <div class="title-row">
          <img
            class="nucleus"
            :src="require('@/assets/images/officialWebsite/buleleft.png')"
          />
          <div class="section-title__text">核心功能</div>
          <img
            class="nucleus"
            :src="require('@/assets/images/officialWebsite/blueright.png')"
          />
        </div>
        <p class="title-eng">Core functions</p>
      </div>
      <ul class="function-list">
        <img class="function-image" :src="require('@/assets/images/products/meeting/core.png')" alt="核心功能" />
        <li
          class="function-item"
          v-for="(item, index) in functionList"
          :key="index"
        >
          <img
            class="function-item__image"
            :src="item.imageUrl"
            :alt="item.label"
          />
          <p class="function-item__label">{{ item.label }}</p>
        </li>
      </ul>
    </div>
    <div class="info-section value" ref="section3">
      <div class="section-title">
        <div class="title-row">
          <img
            class="nucleus"
            :src="require('@/assets/images/officialWebsite/buleleft.png')"
          />
          <div class="section-title__text">应用价值</div>
          <img
            class="nucleus"
            :src="require('@/assets/images/officialWebsite/blueright.png')"
          />
        </div>
        <p class="title-eng">Application value</p>
      </div>
      <ul class="value-list">
        <li class="value-item" v-for="(item, index) in valueList" :key="index">
          <img
            class="value-item__image"
            :src="item.imageUrl"
            :alt="item.label"
          />
          <div class="value-info">
            <p class="value-info__title">{{ item.title }}</p>
            <p class="value-info__text">{{ item.text }}</p>
          </div>
        </li>
      </ul>
    </div>
    </div>
  </div>
</template>

<script>
import ChildTab from '@/components/mobile/child-tab.vue'
export default {
  components: {
    ChildTab
  },
  data () {
    return {
      childrenTabData: ['系统概述', '核心功能', '应用价值'],
      childTabOffsetData: [],
      functionList: [
        {
          imageUrl: require('@/assets/images/products/meeting/meeting3.png'),
          label: '会议室申请'
        },
        {
          imageUrl: require('@/assets/images/products/meeting/meeting1.png'),
          label: '会议通知'
        },
        {
          imageUrl: require('@/assets/images/products/meeting/meeting4.png'),
          label: '物资预订'
        },
        {
          imageUrl: require('@/assets/images/products/meeting/meeting6.png'),
          label: '门禁授权'
        },
        {
          imageUrl: require('@/assets/images/products/meeting/meeting5.png'),
          label: '流程审核'
        },
        {
          imageUrl: require('@/assets/images/products/meeting/meeting7.png'),
          label: '数据统计'
        }
      ],
      valueList: [
        {
          imageUrl: require('@/assets/images/products/meeting/meeting8.png'),
          title: '提高协作效率',
          text: '一个流程内实现会议室预约多部门、多节点、多事项集成，移动审批，减少耗时'
        },
        {
          imageUrl: require('@/assets/images/products/meeting/meeting9.png'),
          title: '服务更多元化',
          text: '有效融合会议周边服务，活化校园资各类源使用，提高会议服务整体质量及体验度'
        },
        {
          imageUrl: require('@/assets/images/products/meeting/meeting10.png'),
          title: '降低管理难度',
          text: '联动校内管控系统，实现对门禁、空调、灯光、多媒体设备的使用授权与开关控制'
        }
      ]
    }
  },
  methods: {
    initTab () {
      for (let i = 1; i <= 3; i++) {
        this.childTabOffsetData.push(this.$refs[`section${i}`].offsetTop)
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.initTab()
    })
  }
}
</script>

<style lang="scss" scoped>
.info-content {
  .outermost-layer{
    position: relative;

  .info-section {
    box-sizing: border-box;
    padding: 20px 0;
    &.overview {
      color: #333;
      padding: 20px;
      .overview-image {
        width: 90%;
        margin: 0 auto;
        display: block;
      }
      .overview-title {
        font-weight: bold;
        font-size: 18px;
      }
      .overview-p {
        margin-top: 20px;
        font-size: 16px;
      }
    }
    &.core {
      color: #333;

      .function-list {
        padding: 20px 0px 25px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        row-gap: 30px;
        position: relative;
        .function-image{
          position: absolute;
          top: 50%;
          left: 50%;
          width: 35%;
          display: block;
          transform: translate(-50%,-50%);
        }
        .function-item {
          text-align: center;
          flex: 0 0 40%;
          display: flex;
          align-items: center;
          justify-content: center;
          &:nth-child(2n){
            flex-direction: row-reverse;
          }
          &:nth-of-type(3){
            transform: translateX(-8%);
          }
          &:nth-of-type(4){
            transform: translateX(8%);
          }

          &__image {
            height: 28px;
            display: block;
            margin: 0 5px;
          }
          &__label {
            font-size: 14px;
            margin: 0 3px;
          }
        }
      }
    }
    &.value {
      color: #333;
      .value-list {
        padding: 20px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: center;
        row-gap: 30px;
        .value-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          border-radius: 5px 5px 5px 5px;
          box-shadow: 0px 2px 7px 1px rgba(44,83,210,0.16);
          &__image {
            width: 100px;
            display: block;
          }
          .value-info {
            &__title {
              color: #2C53D2;
              font-weight: bold;
              font-size: 18px;
            }
            &__text {
              color:#616781;
              margin-top: 5px;
              font-size: 16px;
            }
          }
        }
      }
    }
  }
  }
}
.section-title {
  margin: 0 auto;
  text-align: center;
  .title-row {
    display: flex;
    justify-content: center;
    align-items: center;
    .nucleus {
      height: 10px;
      margin: 0 10px;
    }
    .section-title__text {
      color: #383838;
      font-size: 22px;
    }
  }
  .title-eng {
    font-size: 12px;
    color: #999;
  }
}
</style>
